// Breadcrumb.tsx — Crumb trail used at the top of every drill-in
// route. Strings render as the current (non-linked) crumb; objects
// with `{ label, to }` render as React Router <Link>s.
//
// Crumbs + separators are emitted as DIRECT flex children of the
// container so .console-breadcrumb's `gap: 6px` spaces every "/"
// symmetrically. The earlier shape nested the separator inside
// each crumb's wrapper span, which made the "/" cling to the
// next crumb's text with no internal spacing.

import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export type Crumb = string | { label: string; to: string };

interface Props {
  crumbs: Crumb[];
}

export function Breadcrumb({ crumbs }: Props) {
  if (!crumbs.length) return null;
  return (
    <div className="console-breadcrumb">
      {crumbs.map((c, i) => (
        <Fragment key={`crumb-${i}`}>
          {i > 0 && (
            <span className="console-breadcrumb-sep" aria-hidden="true">
              /
            </span>
          )}
          {typeof c === 'string' ? (
            <span className="console-breadcrumb-current">{c}</span>
          ) : (
            <Link to={c.to}>{c.label}</Link>
          )}
        </Fragment>
      ))}
    </div>
  );
}
